var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.classstyle , _vm.curError ? 'has-error' : '']},[_c('main',[_vm._t("default"),_vm._v(" "),(_vm.curError)?_c('errorinputcomponent',{attrs:{"errors":_vm.curError}}):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }